import Vue from 'vue'
import Router from 'vue-router'
import screenEnter from '@/components/screenEnter/screenEnter'
import screenIndex from '@/components/screenIndex/screenIndex'
import signIn from '@/components/signIn/signIn'
// import discuss from '@/components/discuss/discuss'
import vote from '@/components/vote/vote'
import responder from '@/components/responder/responder'
// import pick from '@/components/pick/pick'
import signDetail from '@/components/signDetail/signDetail'
import loadingIn from '@/components/loadingIn/loadingIn'
import screenCenter from '@/components/screenCenter/screenCenter'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'screenEnter',
      component: screenEnter,
      meta: {
        title: "财道书院投屏"
      }
    },
    {
      path: '/screenCenter',
      name: 'screenCenter',
      component: screenCenter,
      meta: {
        title: "财道书院投屏"
      }
    },
    {
      path: '/loadingIn',
      name: 'loadingIn',
      component: loadingIn,
      meta: {
        title: "财道书院投屏",
        requireAuth: true, // 判断是否有Authorization
      }
    },
    {
      path: '/screenIndex',
      name: 'screenIndex',
      component: screenIndex,
      meta: {
        title: "财道书院投屏",
        requireAuth: true, // 判断是否有Authorization
      },
      children:[
        {
            path:'signIn',//点名
            name:'signIn',
            component:signIn,
            meta: {
              title: "点名",
              requireAuth: true, // 判断是否有Authorization
            }
        },
        // {
        //     path:'discuss',//讨论
        //     name:'discuss',
        //     component:discuss,
        //     meta: {
        //       title: "讨论",
        //       requireAuth: true, // 判断是否有Authorization
        //     }
        // },
        {
            path:'vote',//投票
            name:'vote',
            component:vote,
            meta: {
              title: "投票",
              requireAuth: true, // 判断是否有Authorization
            }
        },
        {
            path:'responder',//抢答
            name:'responder',
            component:responder,
            meta: {
              title: "抢答",
              requireAuth: true, // 判断是否有Authorization
            }
        },
        // {
        //   path:'pick',//选人
        //   name:'pick',
        //   component:pick,
        //   meta: {
        //     title: "选人",
        //     requireAuth: true, // 判断是否有Authorization
        //   }
        // },
        {
          path: 'signDetail',
          name: 'signDetail',
          component: signDetail,
          meta: {
            title: "点名",
            requireAuth: true, // 判断是否有Authorization
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js